import { Component, OnInit, Input } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CommonService } from '../../services/common.service';
import { environment } from '../../../environments/environment';

const oAuthConfig: AuthConfig = {
    issuer: environment.googleCredentials.issuer,
    strictDiscoveryDocumentValidation: environment.googleCredentials.strictDiscoveryDocumentValidation,
    redirectUri: environment.googleCredentials.redirectUri,
    clientId: environment.googleCredentials.clientId,
    scope: environment.googleCredentials.scope
}


@Component({
    selector: 'app-continue-with',
    templateUrl: './continue-with.component.html',
    styleUrls: ['./continue-with.component.scss']
})
export class ContinueWithComponent implements OnInit {
    @Input() isEmailLogin: string = 'true';
    constructor(public authenticationService: AuthenticationService,
        private common: CommonService, private readonly oAuthService: OAuthService,
        private _activatedRoute: ActivatedRoute,
        private router: Router) {
        oAuthService.configure(oAuthConfig);
        oAuthService.logOut();
    }

    ngOnInit(): void {
    }
    LinkedinLogin() {
        var href = environment.linkedInCredentials.authorizationUrl +
            "?response_type=" + environment.linkedInCredentials.response_type +
            "&client_id=" + environment.linkedInCredentials.clientId +
            "&redirect_uri=" + environment.linkedInCredentials.redirectUrl +
            "&scope=" + environment.linkedInCredentials.scope;
        window.location.href = href;
    }
    // Login With Google
    loginGoogle() {
        this.oAuthService.loadDiscoveryDocument().then(
            () => {
                this.oAuthService.tryLoginImplicitFlow().then(
                    () => {
                        if (!this.oAuthService.hasValidAccessToken()) {
                            this.oAuthService.initLoginFlow();
                        }
                    }
                );
            }
        );
    }
    // // Login With Twitter
    loginTwitter(): void {
        //this.authService.signInTwitter();
    }

    // Login With Facebook
    loginFacebook() {
        
    }

    loginEmail() {
        let returnUrl : string = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        this.router.navigate(['/auth/login-email'], { queryParams: { returnUrl: returnUrl } });
    }

    loginMobile() {
        let returnUrl: string = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: returnUrl } });
    }
}
